<ng-template #content>
  <div class="lna-modal-header">
    <div class="d-flex align-items-center gap-2">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.tasks.addArchiveModal.title' | translate }}</h4>
      <app-tooltip text="addArchive" />
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <div class="form-check mb-3">
      <input
        type="checkbox"
        class="form-check-input lna checkbox"
        id="consolidated"
        [(ngModel)]="consolidatedChecked"
        [disabled]="isConsolidatedDisabled" />
      <label for="consolidated">
        {{ 'pages.viewInfoRequest.tasks.addArchiveModal.consolidated' | translate }}
      </label>
    </div>
    <div class="lna-row-32 full-width">
      <label class="form-label lna">
        {{ 'pages.viewInfoRequest.tasks.addArchiveModal.selectUnit' | translate }}
      </label>
      <select class="form-control lna" [(ngModel)]="selectedUnitId">
        <option value="">{{ 'pages.viewInfoRequest.tasks.addArchiveModal.selectUnitPlaceholder' | translate }}</option>
        @for (unit of availableUnits; track unit.id) {
          <option [value]="unit.id">{{ unit.name }}</option>
        }
      </select>
    </div>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="!canSave || isLoading" (click)="confirm()">
      {{ 'pages.viewInfoRequest.tasks.addArchiveModal.add' | translate }}
    </button>
    <button class="secondary" (click)="close()">
      {{ 'pages.viewInfoRequest.tasks.addArchiveModal.cancel' | translate }}
    </button>
  </div>
</ng-template>
